import { HashLocationStrategy, Location, LocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CsxSecurityModule, SecurityConfigInjectionToken } from '@csx/security';
import { MenuModule } from 'primeng/menu';
import { AccordionModule } from 'primeng/accordion';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SliderModule } from 'primeng/slider';
import { StepsModule } from 'primeng/steps';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { ButtonModule } from 'primeng/button';
import { AutoCompleteModule } from 'primeng/autocomplete';

import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { Routing } from './app.routing';
import { AuthorityComponent } from './authority/authority.component';
import { BackHandleComponent } from './backnavigationhandle/backnavigationhandle';
import { AuthorityModificationComponent } from './change-history/authority-modification/authority-modification.component';
import { ChangeHistoryComponent } from './change-history/change-history.component';
import { ChangeRequestModule } from './change-request/change-request.module';
import { CommentComponent } from './comment/comment.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { AuthorityCardComponent } from './createauthority/authority-card/authority-card.component';
import { AvailableAuthorityComponent } from './createauthority/available-authority/available-authority.component';
import { CreateAuthorityComponent } from './createauthority/createauthority.component';
import { DetailAuthorityCardComponent } from './createauthority/detail-request-authority/detail-authority-card/detail-authority-card.component';
import { DetailRequestAuthorityComponent } from './createauthority/detail-request-authority/detail-request-authority.component';
import { HeaderComponent } from './header/header.component';
import { LineItemComponent } from './lineitem/lineitem.component';
import { LogoutComponent } from './logout/logout.component';
import { MainComponent } from './main/main.component';
import { NotificationComponent } from './notification/notification.component';
import { OutageComponent } from './outage/outage.component';
import { ReportsComponent } from './reports/reports.component';
import { UserAlertComponent } from './user-alert/user-alert.component';
import { SecConfig } from './security/security.config';
import { AffirmationService } from './services/affirmation.service';
import { AngularClientService } from './services/angularclient.service';
import { ChangeRequestService } from './services/changerequest.service';
import { DataShareService } from './services/data-share.service';
import { DataService } from './services/data.service';
import { DataSyncService } from './services/datasync.service';
import { EventBusService } from './services/eventbus.service';
import { HttpService } from './services/http.service';
import { HttpClientService } from './services/httpclient.service';
import { LocalStorageService } from './services/localstorage.service';
import { PollService } from './services/poll.service';
import { SystemStatusService } from './services/systemstatus.service';
import { SharedAuthorityModalComponent } from './shared-authority-modal/shared-authority-modal.component';
import { ReleaseSharedAuthorityComponent } from './shared-authority/release-shared-authority/release-shared-authority.component';
import { AuthorityFilterPipe } from './shared/authority.filter';
import { UserConfirmationDialogComponent } from './userconfirmationdialog/userconfirmation.component';
import { UserNotificationComponent } from './usernotification/usernotification.component';
import { UserverificationComponent } from './userverification/userverification.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { CreateTableHeaderComponent } from './shared/create-table-header/create-table-header.component';
import { BrowserSupportComponent } from './browser-support/browser-support.component';
import { DetailAuthorityCardMobileComponent } from './createauthority/detail-request-authority/detail-authority-card-mobile/detail-authority-card-mobile.component';
import { ProxyUser } from './models/proxyuser';
import { provideDatadogErrorHandler, provideDatadogRouter } from '@datadog/browser-rum-angular';

// OIDC Security Implementation
@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    Routing,
    ButtonModule,
    StepsModule,
    BrowserAnimationsModule,
    DialogModule,
    SelectButtonModule,
    InputTextModule,
    CalendarModule,
    SliderModule,
    DropdownModule,
    AccordionModule,
    AutoCompleteModule,
    InputTextareaModule,
    RadioButtonModule,
    HttpClientModule,
    ChangeRequestModule,
    MenuModule,
    CsxSecurityModule.initialize(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production
    })
  ],
  declarations: [
    AppComponent,
    MainComponent,
    ReportsComponent,
    AuthorityComponent,
    UserConfirmationDialogComponent,
    AuthorityFilterPipe,
    CreateAuthorityComponent,
    LineItemComponent,
    NotificationComponent,
    CommentComponent,
    UserNotificationComponent,
    OutageComponent,
    UserAlertComponent,
    HeaderComponent,
    WelcomeComponent,
    UserverificationComponent,
    LogoutComponent,
    BackHandleComponent,
    ChangeHistoryComponent,
    AuthorityModificationComponent,
    ReleaseSharedAuthorityComponent,
    SharedAuthorityModalComponent,
    ConfirmationDialogComponent,
    BackHandleComponent,
    ChangeHistoryComponent,
    CreateTableHeaderComponent,
    AuthorityModificationComponent,
    DetailRequestAuthorityComponent,
    AvailableAuthorityComponent,
    AuthorityCardComponent,
    DetailAuthorityCardComponent,
    BrowserSupportComponent,
    DetailAuthorityCardMobileComponent
  ],
  providers: [
    DataShareService,
    ProxyUser,
    DataService,
    PollService,
    EventBusService,
    LocalStorageService,
    SystemStatusService,
    { provide: HttpService, useClass: HttpClientService },
    AngularClientService,
    DataSyncService,
    AffirmationService,
    ChangeRequestService,
    Location,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: SecurityConfigInjectionToken, useValue: SecConfig },
    provideDatadogErrorHandler(),
    provideDatadogRouter()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
